/**
 * #981 — where the large-CSV grid's viewport is, and putting a row back at its top (a re-open or an in-place
 * swap after a save keeps the person where they were). Its own module so tests can watch the swap use it.
 */
import type { GridApi } from 'ag-grid-community'

/** Rows AG Grid renders above and below the viewport (its default, set so the top row can be read back). */
export const ROW_BUFFER = 10

/**
 * The first row in the viewport. AG Grid's first RENDERED row is ROW_BUFFER rows above it once scrolled
 * past the buffer; near the top the scroll offset says it (no stretch offset there).
 */
export function topVisibleRow(api: Pick<GridApi, 'getFirstDisplayedRowIndex' | 'getVerticalPixelRange' | 'getDisplayedRowAtIndex'>): number {
  const first = api.getFirstDisplayedRowIndex()
  if (first > 0) return first + ROW_BUFFER
  const height = api.getDisplayedRowAtIndex(0)?.rowHeight ?? 0
  return height > 0 ? Math.floor(api.getVerticalPixelRange().top / height) : 0
}

/** Scrolls so display row `row` is the top row (clamped to the rows the grid has). */
export function showRowAtTop(api: Pick<GridApi, 'ensureIndexVisible' | 'getDisplayedRowCount'>, row: number): void {
  api.ensureIndexVisible(Math.min(row, Math.max(0, api.getDisplayedRowCount() - 1)), 'top')
}
